export const getRelationship = permission => {
  if (typeof permission === 'object') {
    return permission.relationship;
  }

  return undefined;
};

export default getRelationship;
